import React from 'react'
import { motion } from 'framer-motion'
import { Container, HeroContent, ImageWrapper, CTAButton } from './styles'

function HomePresentation() {
  return (
    <Container>
      <HeroContent
        as={motion.div}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <b>Uma nova ATLAS. Um novo começo.</b> <br />
          <span>Agora com nova gestão</span>
        </motion.h1>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.98 }}
        >
          <CTAButton href="https://atlasplugins.com/login">
            Entre na comunidade
          </CTAButton>
        </motion.div>
      </HeroContent>
      <ImageWrapper
        as={motion.div}
        initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      />
    </Container>
  )
}

export default HomePresentation